import React, { useEffect, useState } from "react";

import {
    RiCloseLine,
} from "@remixicon/react";
import classNames from "classnames";
import {
    MetricsDashboardInput,
    PermissionAction,
} from "../../../__generated__/api";
import Button from "../../../components/theme/button/Button";
import FormGroup from "../../../components/theme/form-group/FormGroup";

import ShareOptionsSettings from "../../../components/agent-v3/board-toolbar/view-options/ShareOptions";
import ExpandingSection from "../../../components/expanding-section/ExpandingSection";
import Styles from "./BoardToolbar.module.scss";

export function ViewOptions({
    onChange,
    value,
    className,

}: {
    onChange: (value?: MetricsDashboardInput) => void;
    value: MetricsDashboardInput | undefined;
    className?: string
}) {
    return (
        <div className={className}>
            <ExpandingSection title="Report Name" defaultExpanded cardClassName={Styles.expander}>
                <FormGroup
                    size="small"
                    required
                    type="text"
                    onChange={evt => onChange({
                        ...value as MetricsDashboardInput,
                        name: evt.target.value,
                    })}
                    value={value?.name}
                />
            </ExpandingSection>

            <ExpandingSection title="Share Options" defaultExpanded cardClassName={Styles.expander}>
                <ShareOptionsSettings
                    shareTypeLabel="Report"
                    lowerPermission={PermissionAction.Execute}
                    value={value?.permissions ?? []}
                    onChange={permissions => {
                        onChange({
                            ...value as MetricsDashboardInput,
                            permissions,
                        });
                    }}
                />
            </ExpandingSection>
        </div>
    );
}
ViewOptions.defaultProps = {
    className: "",
};

export function CreateEditReportView({
    onChange,
    shouldShow,
    onHide,
    value,
    shouldEdit,
}: {
    onChange: (value?: MetricsDashboardInput) => void;
    onHide: () => void;
    shouldShow: boolean;
    shouldEdit?: boolean;
    value?: MetricsDashboardInput;
}) {
    const [current, setCurrent] = useState(value);
    useEffect(() => {
        setCurrent(value);
    }, [value]);

    useEffect(() => {
        if (shouldShow && !value) {
            setCurrent({
                name: "New Report",
                permissions: [
                    {
                        action: PermissionAction.Execute,
                        assigneeId: undefined,
                    },
                ],
                settings: {
                    graphs: [],
                },
            });
        }
    }, [shouldShow]);

    return (
        <div className={classNames("offcanvas offcanvas-end", shouldShow ? "show" : "")} tabIndex={-1}>
            <div className="offcanvas-header d-flex justify-content-between border-bottom">
                <h4>
                    {shouldEdit ? "Edit" : "Add"}
                    {" "}
                    Report
                </h4>
                <Button variant="none" size="small" onClick={onHide} prefixIcon={<RiCloseLine />} />
            </div>
            <div className={classNames("offcanvas-body", Styles.offcanvas)}>
                <ViewOptions onChange={setCurrent} value={current} className={Styles["view-options"]} />
                <div className={Styles.buttons}>
                    <Button variant="outline-gray" onClick={onHide}>Cancel</Button>
                    <Button onClick={() => onChange(current)}>Save</Button>
                </div>
            </div>
        </div>
    );
}

CreateEditReportView.defaultProps = {
    value: undefined,
    shouldEdit: false,
};
